import './index.less';



// WEBPACK FOOTER //
// ./ecology9/wea-tag/style/index.js